import { type Observable, of, tap } from 'rxjs';

export class TimedObservableValueCache {
  private cache: {
    [key: string]: {
      fetch$?: Observable<any>;
      value?: any;
      ping?: () => void;
      invalidate?: () => void;
    };
  } = {};

  constructor(private timeout: number) {}

  getValue(key: string, fetchFn$: () => Observable<any>): Observable<any> {
    const entry = this.cache[key];
    if (entry?.value && entry.ping) {
      entry.ping();
      return of(entry.value);
    }
    if (entry?.fetch$) {
      return entry.fetch$;
    }
    const fetch$ = fetchFn$().pipe(tap((value) => this.cacheValue(key, value)));
    this.cache[key] = { fetch$ };
    return fetch$;
  }

  invalidateCache(prefix: string): void {
    const matchedCacheItems = Object.entries(this.cache).filter(([key]) => key.startsWith(prefix));
    for (const [, value] of matchedCacheItems) {
      value.invalidate?.();
    }
  }

  private cacheValue(key: string, value: any[]): void {
    let timeout: ReturnType<typeof setTimeout>;
    const updateTimeout = (): ReturnType<typeof setTimeout> =>
      (timeout = setTimeout(() => delete this.cache[key], this.timeout));
    this.cache[key] = {
      value,
      ping: (): void => {
        clearTimeout(timeout);
        updateTimeout();
      },
      invalidate: (): void => {
        clearTimeout(timeout);
        delete this.cache[key];
      },
    };
  }
}
